import React, { useEffect, useCallback, useState} from 'react';
import {setPlanarGradientColor} from 'actions/index.js';
import {ChromePicker} from 'react-color';
import {connect} from 'react-redux';

const GradientColorPicker = ({effect, color, setPlanarGradientColor}) => { 
    color = color || "#ffffff";
    let [gradientColor, setGradientColor] = useState(color);
    let [showPicker, setShowPicker] = useState(false);
    let onChangeColor = useCallback((color) => {
        setPlanarGradientColor(effect.id, color.hex);
        setGradientColor(color);
    }, [setGradientColor, effect]);
    return (
        <div className="gradient-color">
          Gradient Color: <div onClick={() => setShowPicker(!showPicker)} style={{backgroundColor: color}} className="color-dot"/>
          {showPicker &&
           <ChromePicker color={gradientColor} onChange={onChangeColor}></ChromePicker>}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      color: state.plane.gradientColors[props.effect.id]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setPlanarGradientColor: (a,b) => dispatch(setPlanarGradientColor(a,b))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GradientColorPicker);
